// PPPoE Sessions — the "live sessions" list page's data source.
// Backed by GET /v1/api/pppoe/sessions on noc-app (see
// internal/pppoesessions/http.go). Reseller callers see only sessions
// on their granted routers; admin/support see the whole fleet.

import type { ApiClient } from "./client.js";

export interface PppoeSessionRow {
  router: string;
  router_ip: string;
  username: string;
  address: string;
  uptime: string;
  uptime_secs: number;
  caller_id: string;
  service: string;
  status: "online" | "offline" | string;
  bytes_in: number;
  bytes_out: number;
  last_logoff?: string;
  updated_at: string;
}

export interface PppoeSessionsResponse {
  ok: boolean;
  error?: string;
  page: number;
  per: number;
  /** Total sessions the caller can see (before filter/query). Drives "of N" copy. */
  total: number;
  /** Sessions matching the current filter/query — pagination is against this. */
  filtered: number;
  sessions: PppoeSessionRow[];
}

export type PppoeSort = "uptime" | "user" | "bytes_out";
export type PppoeOrder = "asc" | "desc";
export type PppoeStatusFilter = "" | "online" | "offline";

export interface PppoeListParams {
  page?: number;
  per?: number;
  router?: string;
  status?: PppoeStatusFilter;
  q?: string;
  sort?: PppoeSort;
  order?: PppoeOrder;
}

export function makePppoeSessionsApi(client: ApiClient) {
  return {
    /** List live PPPoE sessions. Default sort: uptime desc (newest first). */
    list(params: PppoeListParams = {}) {
      const qs: Record<string, string> = {};
      if (params.page != null) qs.page = String(params.page);
      if (params.per != null) qs.per = String(params.per);
      if (params.router) qs.router = params.router;
      if (params.status) qs.status = params.status;
      if (params.q) qs.q = params.q;
      if (params.sort) qs.sort = params.sort;
      if (params.order) qs.order = params.order;
      return client.get<PppoeSessionsResponse>("/v1/api/pppoe/sessions", qs);
    },
  };
}

export type PppoeSessionsApi = ReturnType<typeof makePppoeSessionsApi>;
